<template>
  <v-form v-model="valid" ref="uploadFile">
    <v-card-text>

        <v-text-field
                :label="`${$t('archive.choose_file')}`"
                @click="onPickFile"
                v-model='fileName'
                prepend-icon="attach_file"
        ></v-text-field>
        <!-- Hidden -->
        <input
                type="file"
                style="display: none"
                ref="fileInput"
                accept="*/*"
                @change="onFilePicked">
        <!-- Kind of logs -->

    <v-text-field
            width="80%"
            v-model="name"
            :label="`${$t('archive.file-name')}`"
            :rules="nameRules"
            required
    ></v-text-field>
    <v-text-field
            width="80%"
            v-model="archType"
            :label="`${$t('archive.arch_type')}`"
    ></v-text-field>
      <v-textarea
            clearable
            clear-icon="cancel"
            :label="`${$t('archive.note')}`"
            v-model="note"
            required
    ></v-textarea>
    </v-card-text>




    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>

      <v-progress-circular
        indeterminate
        color="primary"
        v-if="loading"
        spacing="pr-4"
      ></v-progress-circular>
      <v-btn color="primary" @click="upload" :disabled="loading">
        {{ $t('archive.upload') }}
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
  import http from '@/plugins/http'
export default {
  computed: {
    teams() {
      return this.$store.state.teams
    }
  },
    data() {
      return {
        fileName: '',
        url: '',
        fileObject: null,
        cardResult: '',
        name: '',
        size: '',
        note:'',
        archType:'',
        type: '',
        lastModifiedDate: '',
        loading: false,
        valid: false,
        nameRules: [
          (v) => (!v || v.length >= 2) || this.$t('team.create.error.min-length-3'),
          (v) => !!v || this.$t('team.create.error.no-name-msg'),
          (v) => /[A-ZĄĆĘŁŃÓŚŹŻ]/.test(v.charAt(0).toUpperCase()) || this.$t('team.create.error.first-letter-msg'),
        ]
      }
    },
    methods: {
      onPickFile () {
        this.$refs.fileInput.click()
      },
      onFilePicked (event) {
        const files = event.target.files
        if (files[0] !== undefined) {
          this.fileName = files[0].name
          // Check validity of file
          if (this.fileName.lastIndexOf('.') <= 0) {
            return
          }
          // If valid, continue
          const fr = new FileReader()
          fr.readAsDataURL(files[0])
          fr.addEventListener('load', () => {
            this.url = fr.result
            this.fileObject = files[0] // this is an file that can be sent to server...
            this.onUploadSelectedFileClick();
          })

        } else {
          this.fileName = ''
          this.fileObject = null
          this.url = ''
        }
      },
      onUploadSelectedFileClick () {
        this.loading = true
        if (!this.fileObject) {
          alert('No file!!')
        }
        // DO YOUR JOB HERE with fileObjectToUpload
        // https://developer.mozilla.org/en-US/docs/Web/API/File/File
        this.name = this.fileObject.name
        this.size = this.fileObject.size
        this.type = this.fileObject.type
        this.lastModifiedDate = this.fileObject.lastModifiedDate
        // DO YOUR JOB HERE with fileObjectToUpload
        this.loading = false
      },
      clearForm(){
        this.note=""
        this.fileName=""
        this.name=""
        this.fileObject=null
        this.type=null
        this.archType=""
        this.loading = false;
      },
      upload() {
        if(this.$refs.uploadFile.validate()) {
          this.loading = true


          let formData = new FormData();
          formData.append('file', this.fileObject);
          formData.append('fileName', this.fileName);
          formData.append('note', this.note);
          formData.append('type', this.type);
          formData.append('archType', this.archType);

          http.post('archives/upload',formData,{headers: {'Content-Type': 'multipart/form-data'}}).then((data) => {
            this.$emit("exit",data)
            this.clearForm()
          }).catch(() => this.$emit("exit",{"Status": "SS_Error"}) )
        }
      }
    }
  }


</script>

<style scoped>
</style>
